import React from 'react';
import PropTypes from 'prop-types';
import { Tabs as AntTabs } from 'antd';
import { browserHistory } from 'react-router';
import qs from 'qs';

export default class Tabs extends React.Component {
  static propTypes = {
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.oneOfType(PropTypes.string, PropTypes.node).isRequired,
        content: PropTypes.node.isRequired,
        icon: PropTypes.string,
      })
    ).isRequired,
    onChange: PropTypes.func,
    actions: PropTypes.node,
    storeInUrl: PropTypes.bool,
  };

  static defaultProps = {
    actions: null,
    onChange: null,
    storeInUrl: true,
  };

  state = {
    activeTab: '',
  };

  componentDidMount() {
    if (this.props.storeInUrl) {
      const params = qs.parse(window.location.search.substring(1));
      if (!params || !params.activeTab) {
        const tab = this.props.tabs[0].key;
        this.handleTabChange(tab);
      } else {
        this.handleTabChange(params.activeTab);
      }
    } else {
      this.setState({
        activeTab: this.props.tabs[0].key,
      });
    }
  }

  handleTabChange = (tab) => {
    this.setState({
      activeTab: tab,
    });
    if (this.props.storeInUrl) {
      const params = qs.parse(window.location.search.substring(1));
      params.activeTab = tab;
      browserHistory.replace(`${window.location.pathname}?${qs.stringify(params)}`);
    }
    if (this.props.onChange) {
      this.props.onChange(tab);
    }
  };

  render() {
    return (
      <AntTabs activeKey={this.state.activeTab} tabBarExtraContent={this.props.actions} onChange={this.handleTabChange}>
        {this.props.tabs.map((tab) => (
          <AntTabs.TabPane tab={tab.title} key={tab.key}>
            {tab.content}
          </AntTabs.TabPane>
        ))}
      </AntTabs>
    );
  }
}
